/**
 * @file HOC for redirecting to album folder view if there are
 * selected identities.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, Redirect } from 'react-router-dom';

const WithRequireSelectedIdentities = WrappedComponent =>
  class RequireSelectedIdentities extends Component {
    static propTypes = {
      identities: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
        }),
      ).isRequired,
      match: PropTypes.shape({
        params: PropTypes.shape({
          albumFolderId: PropTypes.string.isRequired,
        }),
      }),
    };

    render() {
      const { identities, match } = this.props;

      return identities.length === 0 ? (
        <Redirect to={`/discover/album-folder/${match.params.albumFolderId}`} />
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  identities: discoverAlbumFolder.identities,
});

export { WithRequireSelectedIdentities };

export default WrappedComponent => {
  return compose(
    withRouter,
    connect(mapStateToProps),
    WithRequireSelectedIdentities,
  )(WrappedComponent);
};
